import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

const OneTrustScript = ({ oneTrustToken, component: Script = (props)=>jsx("script", {
        ...props
    }) })=>{
    if (oneTrustToken == null || oneTrustToken === '') {
        console.warn('[OneTrust Script] Missing token');
        return null;
    }
    return jsxs(Fragment, {
        children: [
            jsx(Script, {
                src: `https://cdn.cookielaw.org/consent/${oneTrustToken}/OtAutoBlock.js`,
                type: "text/javascript"
            }),
            jsx(Script, {
                "data-document-language": "true",
                "data-domain-script": oneTrustToken,
                src: "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js",
                type: "text/javascript"
            }),
            jsx(Script, {
                id: "onetrust-optanon-wrapper",
                type: "text/javascript",
                children: 'function OptanonWrapper() {}'
            })
        ]
    });
};

export { OneTrustScript };
//# sourceMappingURL=script.js.map
